export const API_KEY = "AIzaSyBeTLQiEdJkvTjgAEO2Kgw9T62uYOlk5vM";
export const API_URL = "https://www.googleapis.com/youtube/v3/videos?";
export const TIMEOUT_SEC = 10;
export const VIDEO_ID_LENGTH = 11;
export const btn = document.querySelector(".btn--save");
export const btnDelete = document.querySelector(".btn--delete");
export const container = document.querySelector(".videocard-w");
